// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCcjYfY5zYGhaGAgZrWulI_rrHE0kVbmYs",
  authDomain: "vary-pharmacy-96287.firebaseapp.com",
  projectId: "vary-pharmacy-96287",
  storageBucket: "vary-pharmacy-96287.appspot.com",
  messagingSenderId: "455192280064",
  appId: "1:455192280064:web:48d7487afe51e94107ece5",
  measurementId: "G-Z71CC80G2R",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const authentication = getAuth(app);
